function initInterestToggles() {
  const isMobile = window.innerWidth < 480;
  const toggleGroups = document.querySelectorAll(".interest__toggle");

  toggleGroups.forEach((group) => {
    const btn = group.querySelector(".interest__toggle-btn");
    const title = group.querySelector(".interest__title");
    const target = btn?.dataset.target;
    const menu = document.querySelector(`.interest__menu--${target}`);

    if (!menu || !btn || !title) return;

    btn.replaceWith(btn.cloneNode(true));
    const newBtn = group.querySelector(
      `.interest__toggle-btn[data-target="${target}"]`
    );

    const toggleMenu = () => {
      const expanded = newBtn.getAttribute("aria-expanded") === "true";
      menu.style.display = expanded ? "none" : "block";
      newBtn.setAttribute("aria-expanded", String(!expanded));
    };

    if (isMobile) {
      menu.style.display = "none";
      newBtn.setAttribute("aria-expanded", "false");

      newBtn.addEventListener("click", toggleMenu);
      title.addEventListener("click", toggleMenu);
    } else {
      menu.style.display = "";
      newBtn.setAttribute("aria-expanded", "true");
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initInterestToggles();
  window.addEventListener("resize", initInterestToggles);
});
